import { render, staticRenderFns } from "./PageInvoices.vue?vue&type=template&id=09bb0466&scoped=true"
import script from "./PageInvoices.vue?vue&type=script&lang=js"
export * from "./PageInvoices.vue?vue&type=script&lang=js"
import style0 from "./PageInvoices.vue?vue&type=style&index=0&id=09bb0466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bb0466",
  null
  
)

export default component.exports